import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Col, Button } from 'reactstrap';
import HistologiaFiltro from '../../../histologia/common/histologia-filtro.container';
import * as commonActions from '@common/common.action';
import * as organizarActions from '../../../../componentes/dragdrog/organizarLote/store/organizar.action';
import ArquivamentoApi from '../../arquivamento.api';
import CommonFunctions from '@common/util/functions.common';
import Kamban from './Kamban';
import ModalAdicionarRequisicao from './modais/AdicionarRequisicao';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../../helpers/intlMessage';
import { changePeriod, getDate, obterListagemDePeriodos } from '../../../../helpers';

function RequisicaoPage (props) {
  const intl = useIntl()
  const periodo = CommonFunctions.getPeriodosSubDays(0);
  const dispatch = useDispatch();
  const carregando = useSelector(state => state.commonReducer.showCarregando);
  const functionGetDate = getDate.bind(this);
	const functionChangePeriod = changePeriod.bind(this);
  const functionObterListagemDePeriodos = obterListagemDePeriodos.bind(this);
  const periodos = functionObterListagemDePeriodos(intl);
  const [tecnicoSelecionado, setTecnicoSelecionado] = useState(null);
  const [numeroDoExame, setNumeroDoExame] = useState('');
  const [dataInicial, setDataInicial] = useState(periodo.periodoInicial);
  const [dataFinal, setDataFinal] = useState(periodo.periodoFinal);
  const [lista, setLista] = useState([]);
  const [showModalAdicionarMaterial, setShowModalAdicionarMaterial] = useState(false);
  const [tipoPeriodo, setTipoPeriodo] = useState({ value: 'hoje', label: `${intl.formatMessage({ id: "period.today" })}` });

  const limparFiltro = () => {
    setTecnicoSelecionado('');
    setNumeroDoExame('');
    setDataInicial(null);
    setDataFinal(null);
    setTipoPeriodo('');
  }

  useEffect(() => {
    !showModalAdicionarMaterial && onClickFiltrar();
  }, [showModalAdicionarMaterial]);

  function onChangeData (name, value) {
    if (name === 'periodoInicial') {
      setDataInicial(value);
    } else {
      setDataFinal(value);
    }
  }

  function onClickFiltrar () {
    const objPesquisa = {
      tecnico: tecnicoSelecionado ? tecnicoSelecionado.value : null,
      dataInicial,
      dataFinal,
      numeroDoExame
    };

    filtrar(objPesquisa);
  }

  function filtrar (objPesquisa) {
    const { tecnico, dataInicial, dataFinal, numeroDoExame } = objPesquisa;

    if (tecnico == null && numeroDoExame == '' && ((dataInicial == null) || dataInicial == '') && ((dataFinal == null) || dataFinal == '')) {
      dispatch(commonActions.showAlerta('alerta', intl.formatMessage({id: 'dashboards.general.noFilteredItems'}), 3000));
      return;
    }

    let executarValidacaoDeData =
			((dataInicial != null) && dataInicial != '') ||
			((dataFinal != null) && dataFinal != '');

    let result = {valid: true, message: ''};

    if (executarValidacaoDeData)
      result = CommonFunctions.validaData(dataInicial, dataFinal, intl);

    if (!result.valid) {
      dispatch(commonActions.showAlerta('alerta', result.message, 3000));
      return;
    }

    dispatch(commonActions.showFadeCarregando(true));
    ArquivamentoApi.getRequisicao(
      tecnico,
      dataInicial,
      dataFinal,
      numeroDoExame
    ).then(resp => {
      setLista(resp);
      dispatch(commonActions.showFadeCarregando(false));
      props.showMessageByResults(resp.length);
    });
  }

  function organizar (){
    dispatch(organizarActions.atualizarModal(true));
  }

	function resetarPeriodo() {
		setTipoPeriodo('');
    setDataInicial(null);
    setDataFinal(null);
	}

	function periodoAlterado(e) {
		if (!e || !e.value) {
		  return resetarPeriodo();
		}

		let payload = functionGetDate(e.value);
		payload.dtinicial = payload.dtinicial.toISOString().slice(0, 10);
		payload.dtfinal = payload.dtfinal.toISOString().slice(0, 10);

    setTipoPeriodo(e);
    setDataInicial(payload.dtinicial);
    setDataFinal(payload.dtfinal);
	}

	function mudarIntervaloPeriodo(val) {
		let payload = functionChangePeriod(val);

    setDataInicial(payload.start);
    setDataFinal(payload.end);
	}

	function eventoOnKeyPressData(event) {
		if (event.key === "Enter")
				onClickFiltrar();
	}

  return (
    <div className='mv-arquivamento-page'>
      <ModalAdicionarRequisicao
        onModal={() =>
          setShowModalAdicionarMaterial(!showModalAdicionarMaterial)
        }
        showModalAdicionarMaterial={showModalAdicionarMaterial}
        showMessageByResults={props.showMessageByResults}
        tecnicos={props.tecnicos}
      />
      <Col>
        <HistologiaFiltro
          limparFiltro={limparFiltro}
					intl={intl}
          carregando={carregando}
          tecnicos={props.tecnicos}
          tecnicoSelecionado={tecnicoSelecionado}
          periodoInicial={dataInicial}
          periodoFinal={dataFinal}
          onChangeData={onChangeData}
          onChangeTecnico={setTecnicoSelecionado}
          onChangeNumeroExame={e => setNumeroDoExame(e.target.value)}
          onKeyPressNumeroExame={() => {}}
          numeroDoExame={numeroDoExame}
          onClickSearch={onClickFiltrar}
          onClickOrganize={organizar}
          periodos={periodos}
					periodo={tipoPeriodo}
					onChangePeriodo={periodoAlterado}
					mudarIntervaloPeriodo={mudarIntervaloPeriodo}
					onKeyPressData={eventoOnKeyPressData}
        >
          <Col xs={2} style={{ left: '-10px' }}>
            <Button
              className='btn btn-primary'
              onClick={() =>
                setShowModalAdicionarMaterial(!showModalAdicionarMaterial)
              }
              style={{ height: '38px' }}
              disabled={carregando}
            >
              <i className='fas fa-plus'></i><IntlMessage id="general.materialArchiving.addRequisition" />
            </Button>
          </Col>
        </HistologiaFiltro>
        <div style={{ height: props.altura }}>
          <Kamban lista={lista} />
        </div>
      </Col>
    </div>
  );
}

export default RequisicaoPage;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/tabs/Requisicao/index.js